import { Component, h, Host, ComponentInterface } from '@stencil/core';

@Component({
  tag: 'signet-header-row',
})
export class SignetHeaderRow implements ComponentInterface {
  render() {
    return (
      <Host class="header-row">
        <slot />
      </Host>
    );
  }
}
